import { Component, inject } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { IIcon } from '../../../dashboards/interfaces/tiles/definition-helpers/icon.interface';
import { ILinkButton } from '../../../dashboards/interfaces/tiles/definition-helpers/link-button.interface';
import { IHeroBannerTileInstance } from '../../../dashboards/interfaces/tiles/definitions/hero-banner-tile-definition.interface';
import { CONTENT_ALIGNMENT_OPTIONS } from '../../constants/content-alignment-options.constant';
import { HORIZONTAL_POSITION_OPTIONS } from '../../constants/horizontal-position-options.constant';
import { ICON_STYLES_OPTIONS } from '../../constants/icon-styles.constant';
import { VERTICAL_POSITION_OPTIONS } from '../../constants/vertical-position-options.constant';
import { ISelectOption } from '../../interfaces/select-option.interface';
import { TileCreatorHelpersService } from '../../services/tile-creator-helpers.service';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';
import { TileSetupWizardComponent } from '../tile-setup-wizard.component';

@Component({
  standalone: false,
  selector: 'lib-hero-banner-setup-wizard',
  templateUrl: './hero-banner-setup-wizard.component.html',
  styleUrls: ['../shared-tile-creator-styles.scss', './hero-banner-setup-wizard.component.scss'],
})
export class HeroBannerSetupWizardComponent extends TileSetupWizardComponent<IHeroBannerTileInstance> {
  color: any;

  contentAlignmentOptions: ISelectOption[];
  allPositionOptions: ISelectOption[];
  iconStylesOptions: ISelectOption[];
  fontSizesOptions: string[];

  linkButtonsControl;
  iconsControl;

  constructor(
    private readonly fb: FormBuilder,
    private readonly tileCreatorHelpersService: TileCreatorHelpersService,
    private readonly tileCreatorService: TileCreatorService,
  ) {
    super();

    this.tileInstance = inject(TILE_REQUEST).tileInstance;
  }

  ngOnInit() {
    this.initSelectOptions();
    this.initSetupForms();

    this.hookForm();
  }

  initSelectOptions() {
    this.contentAlignmentOptions = CONTENT_ALIGNMENT_OPTIONS;
    this.allPositionOptions = [...HORIZONTAL_POSITION_OPTIONS, ...VERTICAL_POSITION_OPTIONS];
    this.iconStylesOptions = ICON_STYLES_OPTIONS;
    this.fontSizesOptions = this.tileCreatorHelpersService.generateFontSize();
  }

  initSetupForms() {
    this.setupForm = this.fb.group({
      heading1: [''],
      heading2: [''],
      text: [''],
      contentImg: [''],
      background: [''],
      heading1FontSize: ['6px'],
      heading2FontSize: ['6px'],
      heading1FontColor: ['#000000'],
      heading2FontColor: ['#000000'],
      textFontSize: ['6px'],
      textFontColor: ['#000000'],
      backgroundImageTopOffset: [''],
      backgroundImageRightOffset: [''],
      backgroundImageBottomOffset: [''],
      backgroundImageLeftOffset: [''],
      minHeight: [''],
      alignContent: ['start'],
      contentImgPosition: ['start'],
      linkButtons: this.fb.array([]),
      icons: this.fb.array([]),
    });

    this.linkButtonsControl = this.setupForm.controls.linkButtons as FormArray;
    this.iconsControl = this.setupForm.controls.icons as FormArray;

    if (this.tileInstance) {
      this.setupForm.patchValue(this.tileInstance);

      this.tileInstance.icons?.forEach((icon: IIcon) => {
        this.addIcon(icon);
      });
    }
  }

  kButton(linkButton?: ILinkButton) {
    const linkButtonFormGroup = this.fb.group({
      buttonText: [''],
      buttonIcon: [''],
      routeLink: [''],
      buttonFontSize: [6],
      buttonFontColor: ['#000000'],
      buttonBackgroundColor: ['#000000'],
    });

    linkButtonFormGroup.patchValue(linkButton);

    this.linkButtonsControl.push(linkButtonFormGroup);
  }

  removeLinkButton(linkButtonIndex: number) {
    this.linkButtonsControl.removeAt(linkButtonIndex);
  }

  addIcon(icon?: IIcon) {
    const iconFormGroup = this.fb.group({
      icon: [''],
      iconStyle: ['basic'],
      iconColor: ['#000000'],
      iconOutlineColor: ['#000000'],
      iconBackgroundColor: ['#000000'],
    });

    iconFormGroup.patchValue(icon);

    this.iconsControl.push(iconFormGroup);
  }

  removeIcon(iconColumnIndex: number) {
    this.iconsControl.removeAt(iconColumnIndex);
  }

  onCreate() {
    Object.assign(this.tileInstance, this.getChanges());
    this.tileCreatorService.onChange.next();
  }

  getChanges() {
    return {
      tileType: 'hero-banner',
      canView: 'true',
      ...this.setupForm.value,
    };
  }
}
